// extracted by mini-css-extract-plugin
export default {"cardFooter":"card-footer_cardFooter__bwsok","container":"card-footer_container__zcty9"};